import moment from 'moment';
import getPartnerPackage from 'src/partner-response-package';

import { Timer } from 'src/utils/timer';
import ErrorCodes from 'types/error-codes.enum';
import { createFiltersRange, processRawData, unzipPartnerResponse } from './webworker-utils';

addEventListener('message', (e) => {
  const timer = new Timer();
  const {
    sessionId,
    partner,
    search,
    percentageProgress,
    compression,
    timeout,
    agentCurrency,
    customProxy
  } = e.data;
  search.dates.from = moment(search.dates.from);
  search.dates.to = moment(search.dates.to);

  getPartnerPackage(
    sessionId,
    compression ? 'zip' : undefined,
    partner,
    timeout,
    undefined,
    customProxy
  )
    .then(async (res) => {
      timer.splitTime('Response received');
      const { json, raw } = unzipPartnerResponse(res.data, compression);
      timer.splitTime('Response unzipped');
      const exchangeRates = {
        agentCurrency: agentCurrency ?? 'EUR',
        rates: json.exchangeRates
      };
      const result = processRawData(
        json.offers as any,
        json.stations as any,
        search.rentDays,
        sessionId,
        exchangeRates
      );
      timer.splitTime('Processed raw data');
      timer.stop('Processed');
      postMessage(
        JSON.parse(
          JSON.stringify({
            type: 'partnerResponse',
            data: {
              offers: result.offers,
              stations: result.stations,
              filtersRange: createFiltersRange(result.offers),
              exchangeRates,
              percentageProgress,
              partner,
              timing: timer.getTimesInSeconds(),
              raw
            }
          })
        )
      );
      if (json.offers.length === 0) {
        postMessage({ type: 'emptyResponse' });
      } else {
        postMessage({ type: 'finished' });
      }
    })
    .catch((err) => {
      postMessage({
        type: 'error',
        data: {
          code: ErrorCodes.apiRequestFailed,
          message: `${partner} - ${err.message}`,
          reason: '',
          partnerMessage: '',
          requestId: '',
          details: { partner, timeout, message: err.message, details: err?.details }
        }
      });
    });
});

export default {};
